import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Popup from 'reactjs-popup'
import config from 'config'

import Icon from 'srcReact/components/icons/Icon'
import Accordion from 'srcReact/components/common2/Accordion'
import Spinner from 'srcReact/components/common2/Spinner'
import { isWideScreen } from 'srcReact/helpers/utils'

import { settingsActions as sa } from '../../action'
import NotificationHeading from '../NotificationHeading'
import OptionsToggle from '../OptionsToggle'
import AccordionHeading from '../AccordionHeading'
import styles from './styles.module.scss'
import { urlSearchParams } from 'srcReact/helpers/utils'
import parentStyles from '../../styles.module.scss'

export default function GroupForm() {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { isNative } = useSelector((state) => state.common)
  const { current_organization } = useSelector((state) => state.organization)
  const {
    groupDetails,
    groupFormActive,
    notificationList,
    loading,
    notificationSettingUpdated,
    toggleAllSetting,
    toggleAllGroupSetting
  } = useSelector((state) => state.settings)

  const [isDesktop, setIsDesktop] = useState(isWideScreen())

  useEffect(() => {
    window.scrollTo(0, 0)
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  const handleWindowSizeChange = () => {
    setIsDesktop(isWideScreen())
  }

  useEffect(() => {
    // nativeapp
    if (isNative) {
      const payload = {
        id_organization: urlSearchParams('organization_id'),
        id_type: 'group',
        group_id: groupDetails.id,
        group_role: groupDetails.role
      }
      dispatch(sa.getNotificationSettings(payload))
      return
    }
    const payload = {
      id_organization: current_organization.info.id,
      id_type: 'group',
      group_id: groupDetails.id,
      group_role: groupDetails.role
    }
    dispatch(sa.getNotificationSettings(payload))
  }, [notificationSettingUpdated, toggleAllSetting, toggleAllGroupSetting, groupDetails])

  const groupNotificationsData = () => {
    let groupNotifications = []
    Object.keys(notificationList).map((nl, index) => {
      if (nl !== 'mute') {
        let groupData = {
          title: <AccordionHeading title={notificationList[nl].title} data={notificationList[nl]} />,
          description: <OptionsToggle options={notificationList[nl]} key={index} handleOptions={handleGroupToggle} />
        }
        groupNotifications.push(groupData)
      }
    })
    return groupNotifications
  }

  const handleClose = () => {
    dispatch(sa.setGroupFormActive(false))
  }

  const handleGroupToggle = (payload) => {
    dispatch(sa.updateNotificationSettings('group', payload))
  }

  const handleToggle = (payload) => {
    dispatch(sa.toggleAllGroupSettings(payload))
  }

  const renderContent = () => {
    return (
      <div className={`${styles.mainWrapper}`}>
        <div className={`${styles.boxWrapper}`}>
          <div className={`${styles.closeWrapper}`}>
            <button className={`${styles.closeIcon}`} onClick={handleClose}>
              <Icon name='close' alt='close' />
            </button>
          </div>
          <h2 className={`${styles.header}`}>{t('notification_settings.group_form.heading')}</h2>
          <div className={`${styles.groupTitle}`}>
            <img
              src={`${groupDetails?.picture?.url || `${config.assetUrl}/images/background-default-mixr.jpeg`}`}
              alt={groupDetails.picture.name}
            />
            <h2>{groupDetails.name}</h2>
          </div>
          {loading ? (
            <Spinner customCss={styles.loader} />
          ) : (
            <div className={`${styles.bodyWrapper}`}>
              <div className={`${styles.headingWrapper}`}>
                <NotificationHeading
                  heading={t('notification_settings.group_form.receive_notifications_heading')}
                  description={t('notification_settings.group_form.group_receive_description')}
                />
                {Object.keys(notificationList).map((nl, index) =>
                  nl === 'mute' ? (
                    <OptionsToggle
                      key={index}
                      id_type={'group'}
                      toggle_type={'global'}
                      options={notificationList[nl]}
                      handleOptions={handleToggle}
                    />
                  ) : (
                    ''
                  )
                )}
              </div>
              <div className={`${styles.headingWrapper}`}>
                <NotificationHeading
                  heading={t('notification_settings.group_form.group_notifications')}
                  description={t('notification_settings.group_form.group_description')}
                />
                <Accordion data={groupNotificationsData()} className={parentStyles.notificationAccordion} />
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <React.Fragment>
      {isDesktop ? (
        <React.Fragment>{renderContent()}</React.Fragment>
      ) : (
        <Popup
          modal
          //  lockScroll
          className='groupNotificationModal'
          open={groupFormActive}
          onClose={() => dispatch(sa.setGroupFormActive(false))}
          position='top center'
          overlayStyle={{ background: 'rgba(4, 3, 11, 0.3)', padding: '5rem 0 0 0', overflowY: 'scroll' }}
          contentStyle={{
            width: '100%',
            maxWidth: '37.5rem',
            padding: '0px',
            borderRadius: '1.375rem',
            boxShadow: '0.313rem 0.125rem 0.625rem 0 rgba(14, 11, 40, 0.15)',
            background: 'white',
            border: 'none'
          }}>
          {renderContent()}
        </Popup>
      )}
    </React.Fragment>
  )
}
